import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const presidentDetails = createAsyncThunk(
  "presidentDetails",
  async (id) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");

      const response = await AxiosInstance.get(
        `${API_KEY}/api/president/details/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  presidentDetailsData: null,
  isError: false,
  errorMessage: "",
};

const presidentDetailsSlice = createSlice({
  name: "presidentDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(presidentDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(presidentDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.presidentDetailsData = action.payload;
    });
    builder.addCase(presidentDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default presidentDetailsSlice.reducer;
